<template>
    <el-select v-model="value">
      <el-option 
        v-for="item in schoolData" 
        :key="item.id" 
        :value="item.id"
        :label="item.name"
      ></el-option>
    </el-select>
</template>

<script>
export default {
  name: 'School',
  data() {
    return {
      schoolData: [],
      value: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.mixin_getSelectSchool().then(data => {
        this.schoolData = data
      })
    }
  }
}
</script>

<style>

</style>